<!--
 * @Description: 
 * @Date: 2023-08-15 14:56:01
-->
<template>
  <div>
    <el-table
      v-loading="loading"
      :data="tableData"
      style="width: 100%"
      :stripe="true"
      :highlight-current-row="false"
    >
      <el-table-column
        type="index"
        label="序号"
        align="center"
      ></el-table-column>
      <el-table-column
        label="文件名称"
        align="center"
        prop="downloadName"
      ></el-table-column>
      <el-table-column label="文件大小" align="center" prop="fileSize">
        <template slot-scope="scope">
          <span>{{ scope.row.fileSize || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            :disabled="scope.row.urlStatus === 2"
            @click="download(scope.row)"
          >
            下载
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'download-center-download-list',
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    download(row) {
      if (!row.downloadUrl) {
        this.$message.error('无下载数据');
        return;
      }
      this.$downloadFile(row.downloadUrl, true, row.downloadName);
    }
  }
};
</script>
